import React, { Fragment } from "react";
import { revisasPresupuesto } from "../helpers";

const ControlPresupuesto = ({ presupuesto, restante }) => {
  return (
    <Fragment>
      <div className="alert alert-primary">Presupuesto:$ {presupuesto}</div>
      <div className={revisasPresupuesto(presupuesto, restante)}>
        Restante:${restante}
      </div>
    </Fragment>
  );
};

export default ControlPresupuesto;
